//@flow
import * as Immutable from 'immutable';

import {
    TeamSettings,
    GeocodingPreferences
} from 'common/models/flow/TeamSettings';
import type {
    TeamSettingsModelType,
    GeocodingPreferencesModelType
} from 'common/models/flow/TeamSettings';

import { MapControls } from './MapControls';

class InternalTeamSettings extends TeamSettings {
    static fromJS(json: TeamSettingsModelType): InternalTeamSettings {
        const state: Object = Object.assign({}, json);
        state.geocodingPreferences = InternalGeocodingPreferences.fromJS(
            state.geocodingPreferences
        );
        state.mapControls = MapControls.fromJS(state.mapControls);
        return new this(Immutable.Map(state));
    }

    get geocodingPreferences(): InternalGeocodingPreferences {
        return this._state.get('geocodingPreferences');
    }

    get mapControls(): MapControls {
        return this._state.get('mapControls');
    }
}

class InternalGeocodingPreferences extends GeocodingPreferences {
    static fromJS(
        json: GeocodingPreferencesModelType
    ): InternalGeocodingPreferences {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export {
    InternalTeamSettings as TeamSettings,
    InternalGeocodingPreferences as GeocodingPreferences
};
